import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'modal-confirm-resume',
  template: require('./modal-confirm-resume.component.pug'),
  styles: [require('./modal-confirm-resume.component.css').toString()],
})
export class ModalConfirmResumeComponent implements OnInit {
  // Options to pass to the modal:
  onResume: (onFailure: onSmartFailure, resumeAt) => void;
  public reason: Subject<any>;
  title = 'Confirm resuming applications';
  confirmText = 'Please confirm, there is no undo possible for this action.';
  buttonTitle = 'Resume';

  bsResumeAt = null;
  tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(9,0,0);
  placeholder = moment(this.tomorrow).format('L LT'); // placeholder matching bsDatePicker's format
  formatHelp = `Date format: "${this.placeholder}" (${moment.localeData()['_longDateFormat']['L']})`;
  minDate = new Date();
  maxDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
  resumeOption = 'immediately';
  warning = null;
  warningClass = null;

  bsConfig = {
    dateInputFormat: 'L LT', // locale date and locale time
    containerClass: 'theme-default',
    isAnimated: true,
    returnFocusToInput: true,
    showWeekNumbers: false,
  };

  // -------------------------------------------------------------------
  constructor(public bsModalRef: BsModalRef) {
    this.minDate.setDate(this.minDate.getDate());
    this.maxDate.setDate(this.maxDate.getDate());
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  resume(_data: any, _onsuccess: onSmartSuccess, onFailure: onSmartFailure) {
    if (this.resumeOption == 'immediately') {
      this.onResume(onFailure, null);
    } else {
      this.onResume(onFailure, this.bsResumeAt.valueOf());
    }
  }

  // -------------------------------------------------------------------
  ready(): boolean {
    if (this.resumeOption == 'immediately') return true;
    if (this.bsResumeAt && this.bsResumeAt < this.maxDate) return true;

    return false;
  }
  
  // -------------------------------------------------------------------
  onResumeAtValueChange(value: any): void {
    this.warning = null;
    this.bsResumeAt = value;
    this.maxDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

    if (this.bsResumeAt) {
      if (this.bsResumeAt < this.minDate) {
        this.warningClass = { 'text-info': true };
        this.warning = "You've selected a time in the past. Applications will resume immediately.";
      } else if (this.bsResumeAt > this.maxDate) {
        this.warningClass = { 'text-danger': true };
        this.warning = "You can only reschedule applications up to one year into the future.";
      }
    }

  }

  // -------------------------------------------------------------------
  resumeOptionChanged(value: any): void {
    if (value == 'custom') {
      // bsDatePicker uses the time when component was mounted, which is earlier than this
      // to prevent the awkward warning for "past time selected", we set the default to the current time at this point
      if (!this.bsResumeAt) this.bsResumeAt = new Date();

      let date = this.bsResumeAt;
      this.bsResumeAt = null;
      // this is a workaround for a bsDatePicker bug: https://github.com/valor-software/ngx-bootstrap/issues/3553
      // we set a timeout to populate these values after the datepicker is initialized
      setTimeout(() => {
        this.bsResumeAt = date;
      }, 0)
    }
  }

  // -------------------------------------------------------------------
  showPastWarning(): boolean {
    if (!this.bsResumeAt) return false;

    return this.bsResumeAt < this.minDate;
  }

}
